export interface DeviceCapabilities {
  logicalProcessors: number;
  deviceMemoryGb: number | null;
  offscreenCanvas: boolean;
  webgl2: boolean;
  webgpu: boolean;
  recommendedWorkers: number;
  tier: 'básico' | 'intermediário' | 'alto';
  renderThreshold: number;
  cullingMarginPx: number;
}

type NavigatorWithMemory = Navigator & { deviceMemory?: number; gpu?: unknown };

export function detectDeviceCapabilities(): DeviceCapabilities {
  const nav = navigator as NavigatorWithMemory;
  const logicalProcessors = Math.max(1, nav.hardwareConcurrency || 2);
  const deviceMemoryGb = typeof nav.deviceMemory === 'number' ? nav.deviceMemory : null;
  const offscreenCanvas = typeof OffscreenCanvas !== 'undefined';
  const canvas = document.createElement('canvas');
  const webgl2 = Boolean(canvas.getContext('webgl2'));
  const webgpu = 'gpu' in nav;

  const memoryScore = deviceMemoryGb ?? 4;
  const score = logicalProcessors + memoryScore + (webgl2 ? 2 : 0) + (webgpu ? 2 : 0);
  const tier = score >= 18 ? 'alto' : score >= 10 ? 'intermediário' : 'básico';
  const recommendedWorkers = Math.max(1, Math.min(logicalProcessors - 1, tier === 'alto' ? 8 : tier === 'intermediário' ? 4 : 2));

  const renderThreshold = tier === 'alto' ? 700 : tier === 'intermediário' ? 380 : 180;
  const cullingMarginPx = tier === 'alto' ? 620 : tier === 'intermediário' ? 420 : 260;
  return { logicalProcessors, deviceMemoryGb, offscreenCanvas, webgl2, webgpu, recommendedWorkers, tier, renderThreshold, cullingMarginPx };
}
